import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { toast } from "react-toastify";

import MetaFilialService from "../../services/resource/MetaFilialService";
import FilialService from "../../services/resource/filialService";
import { CustomDropdown } from "../../componentes/dropdown/CustomDropdown";
import Button from "../../componentes/button/button";
import MargemService from "../../services/resource/MargemService";


export default function GerenciamentoMetaFilial() {

    const service = new MetaFilialService();
    const margemService = new MargemService();
    const filialService = new FilialService();

    const [loading, setLoading] = useState(false);

    const [listaFiliais, setListaFiliais] = useState([]);

    const [selectedFilters, setSelectedFilters] = useState({
        filialId: null,
        ano: 2026
    });

    const [metas, setMetas] = useState([]);

    const [margemAcumulada, setMargemAcumulada] = useState();

    const [showModal, setShowModal] = useState(false);

    const [saving, setSaving] = useState(false);

    const MESES = [
        "JANEIRO",
        "FEVEREIRO",
        "MARCO",
        "ABRIL",
        "MAIO",
        "JUNHO",
        "JULHO",
        "AGOSTO",
        "SETEMBRO",
        "OUTUBRO",
        "NOVEMBRO",
        "DEZEMBRO",
    ];

    useEffect(() => {

        document.title = "MyDash | Meta Filial";

        filialService.listar()
            .then(res => {
                setListaFiliais(res.data);
            })
            .catch(err => {
                console.error(err);
            });

    }, []);

    useEffect(() => {

        if (
            selectedFilters?.filialId &&
            selectedFilters?.ano
        ) {
            fetchMetas();
            fetchMargem();
        }

    }, [selectedFilters]);

    const fetchMetas = () => {
        setLoading(true);

        service.listarPorFilialEAno(selectedFilters.filialId, selectedFilters.ano)
            .then(res => {
                setMetas(res.data || []);
            })
            .catch(err => { console.error(err); })
            .finally(() => {
                setLoading(false);
            });
    };

    const fetchMargem = () => {
        margemService.buscarPorFilialEAno(selectedFilters.filialId, selectedFilters.ano)
            .then(res => {
                setMargemAcumulada(res.data.margem || null);
            })
            .catch(err => { console.error(err); });
    };

    const criarEstrutura = () => {

        if (!selectedFilters?.filialId) {
            toast.warning("Selecione uma filial");
            return;
        }

        setLoading(true);

        service.criarEstruturaAno({
            filialId: selectedFilters.filialId,
            ano: selectedFilters.ano
        })
            .then(res => {

                setMetas(res.data);

                toast.success("Estrutura criada com sucesso!");

            })
            .catch(err => {

                console.error(err);

                toast.error(
                    err?.response?.data?.message ||
                    "Erro ao criar estrutura"
                );

            })
            .finally(() => {

                setLoading(false);

            });
    };

    const handleChangeValor = (
        mes,
        field,
        value
    ) => {

        setMetas(prev =>
            prev.map(meta =>
                meta.mes === mes
                    ? {
                        ...meta,
                        [field]: value
                    }
                    : meta
            )
        );
    };

    const salvar = async () => {

        try {

            setSaving(true);

            await Promise.all([
                ...metas.map(meta => service.atualizar(meta.id, {
                    margem: meta.margem,
                    valorUnitario: meta.valorUnitario,
                    volume: meta.volume,
                    cubos: meta.cubos,
                    caixasFisicas: meta.caixasFisicas,
                    caixasUnitarias: meta.caixasUnitarias
                })),
                margemService.salvar({
                    filialId: selectedFilters.filialId,
                    ano: selectedFilters.ano,
                    margem: margemAcumulada
                })
            ]);

            toast.success("Metas atualizadas com sucesso!");

            setShowModal(false);

            fetchMetas();
            fetchMargem();

        } catch (error) {

            console.error(error);

            toast.error("Erro ao salvar metas");

        } finally {

            setSaving(false);

        }
    };

    return (

        <div className="min-h-screen bg-background p-4 md:p-6">

            {/* HEADER ACTIONS */}
            <div className="
                mb-4 flex flex-col gap-3 rounded-2xl border border-border bg-card p-4 shadow-card md:flex-row md:items-end
            ">

                <div className="w-full md:w-[280px]">

                    <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-muted-foreground">Filial</label>

                    <CustomDropdown
                        value={selectedFilters.filialId}
                        options={listaFiliais}
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="Selecione a filial"
                        onChange={(e) =>
                            setSelectedFilters(prev => ({
                                ...prev,
                                filialId: e.value
                            }))
                        }
                    />

                </div>

                <div className="w-full md:w-[140px]">

                    <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-muted-foreground">Ano</label>

                    <InputNumber
                        value={selectedFilters.ano}
                        onValueChange={(e) =>
                            setSelectedFilters(prev => ({
                                ...prev,
                                ano: e.value
                            }))
                        }
                        useGrouping={false}
                    />

                </div>

                <div className="flex items-end md:ml-auto">

                    <Button
                        type="button"
                        label="Criar Estrutura"
                        iconLeft="fa fa-layer-group"
                        variant="indigo"
                        loading={loading}
                        onClick={criarEstrutura}
                    />

                </div>

            </div>

            {/* CARD */}
            <div className="
                overflow-hidden rounded-2xl border border-border bg-card pb-5 shadow-card
            ">

                <div className="
                    flex items-center justify-between
                    flex-col gap-3 px-5 py-5 border-b border-border sm:flex-row
                ">

                    <div>

                        <h2 className="
                            text-xl font-bold tracking-tight text-foreground
                        ">
                            Meta Filial
                        </h2>

                        <p className="
                            text-sm text-muted-foreground
                        ">
                            Configure margem e valor unitário.
                        </p>

                    </div>

                    {metas?.length > 0 && (

                        <Button
                            label="Editar Metas"
                            iconLeft="fa fa-pen"
                            variant="green"
                            onClick={() => setShowModal(true)}
                        />

                    )}

                </div>

                {/* EMPTY */}
                {!loading && metas?.length === 0 && (

                    <div className="
                        p-12 flex flex-col items-center
                        justify-center text-center
                    ">

                        <i className="
                            fa fa-chart-column
                            text-5xl text-muted-foreground/40 mb-4
                        "></i>

                        <div className="
                            text-lg font-semibold text-foreground
                        ">
                            Nenhuma meta encontrada
                        </div>

                        <div className="
                            text-sm text-muted-foreground mt-1
                        ">
                            Crie a estrutura anual da filial.
                        </div>

                    </div>

                )}

                <div className="mx-5 mt-5 flex items-center justify-between rounded-xl border border-primary/15 bg-accent p-4">

                    <div><div className="text-sm font-semibold text-accent-foreground">Margem acumulada</div><div className="mt-1 text-sm text-primary">Indicador anual da filial selecionada</div></div>
                    <div className="rounded-lg bg-card px-4 py-2 text-right shadow-xs"><div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Total</div><div className="font-display text-xl font-bold text-primary">{margemAcumulada ?? 0}%</div></div>

                </div>
                {/* GRID */}
                {metas?.length > 0 && (

                    <div className="
                        grid grid-cols-2
                        md:grid-cols-3
                        lg:grid-cols-4
                        xl:grid-cols-6
                        gap-3 px-5 py-4
                    ">

                        {MESES.map((mes) => {

                            const meta = metas.find(
                                m => m.mes === mes
                            );

                            if (!meta) return null;

                            return (

                                <div
                                    key={mes}
                                    className="
                                        rounded-xl border border-border bg-card p-4 shadow-card transition-all duration-150 hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-soft
                                    "
                                >

                                    <div className="
                                        text-sm font-semibold
                                        text-foreground mb-3
                                    ">
                                        {mes}
                                    </div>

                                    <div className="
                                        space-y-3 text-sm
                                    ">

                                        <div>
                                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                                                Margem
                                            </div>

                                            <div className="font-semibold text-foreground">
                                                {meta.margem || 0}%
                                            </div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                                                Valor Unitário
                                            </div>

                                            <div className="font-semibold text-foreground">
                                                R$ {(meta.valorUnitario || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                                                Meta Caixa Unitária
                                            </div>

                                            <div className="font-semibold text-foreground">
                                                R$ {meta.caixasUnitarias || 0}
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            );

                        })}

                    </div>

                )}

            </div>

            {/* MODAL */}
            <Dialog
                visible={showModal}
                onHide={() => setShowModal(false)}
                style={{ width: '98%' }}
                className="max-w-[1500px]"
                blockScroll={true}
                header={(
                    <div><div className="text-lg font-bold text-foreground">Editar metas da filial</div><div className="mt-1 text-sm font-normal text-muted-foreground">Preencha os valores mensais e salve ao finalizar.</div></div>
                )}
                footer={(
                    <div className="
                        flex justify-end gap-2 pt-3
                    ">

                        <Button
                            variant="gray"
                            label="Cancelar"
                            iconLeft="fa fa-arrow-left"
                            onClick={() => setShowModal(false)}
                        />

                        <Button
                            label="Salvar Alterações"
                            iconLeft="fa fa-check"
                            variant="indigo"
                            loading={saving}
                            onClick={salvar}
                        />

                    </div>
                )}
            >

                <label className="mb-5 flex flex-col gap-3 rounded-xl border border-primary/15 bg-accent p-4 text-md font-semibold sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        Valor da Margem (%)
                    </div>

                    <div >
                        <div className="mb-1 text-xs font-semibold text-primary">
                            ACUMULADO TOTAL
                        </div>
                        <div className="space-y-1">
                            <div>

                                <InputNumber
                                    value={margemAcumulada}
                                    onValueChange={(e) => setMargemAcumulada(e.target.value)}
                                    mode="decimal"
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    locale="pt-BR"
                                    onFocus={(e) =>
                                        e.target.select()
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </label>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
                    {MESES.map((mes) => {
                        const meta = metas.find(
                            m => m.mes === mes
                        );

                        if (!meta) return null;

                        return (

                            <div key={mes}                            >

                                <div className="
                                    text-xs font-semibold
                                    text-foreground mb-0
                                ">
                                    {mes}
                                </div>

                                <div className="space-y-1">
                                    <div>

                                        <InputNumber
                                            value={meta.margem}
                                            onValueChange={(e) =>
                                                handleChangeValor(
                                                    mes,
                                                    "margem",
                                                    e.value
                                                )
                                            }
                                            mode="decimal"
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            locale="pt-BR"
                                            onFocus={(e) =>
                                                e.target.select()
                                            }
                                        />

                                    </div>
                                </div>
                            </div>

                        );

                    })}
                </div>

                <label className="mt-6 block border-t border-border pt-5 text-md font-semibold text-foreground">
                    Valor Unitário (R$)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
                    {MESES.map((mes) => {

                        const meta = metas.find(
                            m => m.mes === mes
                        );

                        if (!meta) return null;

                        return (

                            <div key={mes}                            >

                                <div className="
                                    text-xs font-semibold
                                    text-foreground mb-0
                                ">
                                    {mes}
                                </div>

                                <div className="space-y-1">
                                    <div>
                                        <InputNumber
                                            value={meta.valorUnitario}
                                            onValueChange={(e) =>
                                                handleChangeValor(
                                                    mes,
                                                    "valorUnitario",
                                                    e.value
                                                )
                                            }
                                            mode="decimal"
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            locale="pt-BR"
                                            onFocus={(e) =>
                                                e.target.select()
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        );

                    })}



                </div>

                <label className="mt-6 block border-t border-border pt-5 text-md font-semibold text-foreground">
                    Caixas Unitárias (UN)
                </label>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
                    {MESES.map((mes) => {

                        const meta = metas.find(
                            m => m.mes === mes
                        );

                        if (!meta) return null;

                        return (

                            <div key={mes}                            >

                                <div className="
                                    text-xs font-semibold
                                    text-foreground mb-0
                                ">
                                    {mes}
                                </div>

                                <div className="space-y-1">
                                    <div>
                                        <InputNumber
                                            value={meta.caixasUnitarias}
                                            onValueChange={(e) =>
                                                handleChangeValor(
                                                    mes,
                                                    "caixasUnitarias",
                                                    e.value
                                                )
                                            }
                                            mode="decimal"
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            locale="pt-BR"
                                            onFocus={(e) =>
                                                e.target.select()
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        );

                    })}
                </div>

                <label className="mt-6 block border-t border-border pt-5 text-md font-semibold text-foreground">
                    Caixas Fisicas (CX FIS)
                </label>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
                    {MESES.map((mes) => {

                        const meta = metas.find(
                            m => m.mes === mes
                        );

                        if (!meta) return null;

                        return (

                            <div key={mes}                            >

                                <div className="
                                    text-xs font-semibold
                                    text-foreground mb-0
                                ">
                                    {mes}
                                </div>

                                <div className="space-y-1">
                                    <div>
                                        <InputNumber
                                            value={meta.caixasFisicas}
                                            onValueChange={(e) =>
                                                handleChangeValor(
                                                    mes,
                                                    "caixasFisicas",
                                                    e.value
                                                )
                                            }
                                            mode="decimal"
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            locale="pt-BR"
                                            onFocus={(e) =>
                                                e.target.select()
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        );

                    })}
                </div>

                <label className="mt-6 block border-t border-border pt-5 text-md font-semibold text-foreground">
                    Cubos (Med4)
                </label>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
                    {MESES.map((mes) => {

                        const meta = metas.find(
                            m => m.mes === mes
                        );

                        if (!meta) return null;

                        return (

                            <div key={mes}                            >

                                <div className="
                                    text-xs font-semibold
                                    text-foreground mb-0
                                ">
                                    {mes}
                                </div>

                                <div className="space-y-1">
                                    <div>
                                        <InputNumber
                                            value={meta.cubos}
                                            onValueChange={(e) =>
                                                handleChangeValor(
                                                    mes,
                                                    "cubos",
                                                    e.value
                                                )
                                            }
                                            mode="decimal"
                                            minFractionDigits={2}
                                            maxFractionDigits={2}
                                            locale="pt-BR"
                                            onFocus={(e) =>
                                                e.target.select()
                                            }
                                        />

                                    </div>

                                </div>

                            </div>

                        );

                    })}
                </div>

            </Dialog>

        </div>
    );
}
